module.exports = __webpack_public_path__ + "media/images/area/feature/tohoku/02-dfb503526732cebcf3150b5e21c37260.jpg";